import {
  type IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useMemo } from 'react';
import { SebastianStatus } from '~/constants/common/SebastianStatus';
import { useSetSebastianStatus } from '~/context/common/SebastianContext';

type SebastianReadinessPayload = { isLoaded: boolean };

function isSebastianReadinessMessage<ListenerEventType>(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, SebastianReadinessPayload> {
  return (
    message.event === ListenerEvent.SebsReadiness &&
    message.payload != null &&
    typeof message.payload.isLoaded === 'boolean'
  );
}

export default function useSebastianReadinessHandler<
  ListenerEventType
>(): MessageHandler<ListenerEventType, SebastianReadinessPayload> {
  const setSebastianStatus = useSetSebastianStatus();

  return useMemo(
    () =>
      new MessageHandler(isSebastianReadinessMessage, message => {
        setSebastianStatus(
          message.payload.isLoaded
            ? SebastianStatus.Ready
            : SebastianStatus.Error
        );
      }),
    [setSebastianStatus]
  );
}
